// Contact Us page functionality
class ContactUsManager {
  constructor() {
    // Constructor - initialization happens in init()
  }
  
  init() {
    // Initialize FAQ interactions
    this.setupFAQ();
  }
  
  setupFAQ() {
    try {
      console.log('Setting up FAQ functionality');
      
      // 使用更直接的方法 - 先检查是否能够找到FAQ元素
      console.log('Looking for FAQ items...');
      
      // 创建一个简单的独立函数来处理FAQ点击
      function initSimpleFAQ() {
        const faqItems = document.querySelectorAll('.faq-item');
        console.log(`Found ${faqItems.length} FAQ items in initSimpleFAQ`);
        
        faqItems.forEach((item, index) => {
          const question = item.querySelector('.question');
          if (!question) {
            console.warn(`FAQ item ${index} missing question element`);
            return;
          }
          
          // 确保初始状态为折叠
          item.setAttribute('expanded', 'false');
          
          // 添加简单的点击事件处理
          question.onclick = function() {
            const isExpanded = item.getAttribute('expanded') === 'true';
            const newState = isExpanded ? 'false' : 'true';
            
            console.log(`FAQ item clicked: current=${isExpanded}, new=${newState}`);
            item.setAttribute('expanded', newState);
          };
          
          console.log(`FAQ item ${index} initialized with event listener`);
        });
      }
      
      // 立即执行简单的FAQ初始化
      initSimpleFAQ();
      
      // 同时保留原有的完整功能，确保兼容性
      const faqItems = document.querySelectorAll('.faq-item');
      
      if (faqItems.length === 0) {
        console.warn('No FAQ items found for complete setup');
        return;
      }
      
      faqItems.forEach((item, index) => {
        const question = item.querySelector('.question');
        const answer = item.querySelector('.answer');
        
        if (!question || !answer) {
          console.warn(`FAQ item ${index + 1} is missing required elements`);
          return;
        }
        
        // Setup feedback buttons with event propagation prevention
        const likeBtn = answer.querySelector('.answer__feedback__like');
        const dislikeBtn = answer.querySelector('.answer__feedback__dislike');
        
        if (likeBtn) {
          likeBtn.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent triggering the question click
            this.trackFeedback('like', index);
          });
        }
        
        if (dislikeBtn) {
          dislikeBtn.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent triggering the question click
            this.trackFeedback('dislike', index);
          });
        }
      });
    } catch (error) {
      console.error('Error setting up FAQ functionality:', error);
    }
  }
  
  trackFeedback(type, index) {
    // Create or get the feedback thanks element
    let feedbackThanks = document.querySelector('.feedback-thanks');
    
    if (!feedbackThanks) {
      feedbackThanks = document.createElement('div');
      feedbackThanks.className = 'feedback-thanks';
      feedbackThanks.textContent = 'Thank you for your feedback!';
      
      // Find a suitable place to insert the feedback message
      const faqBlock = document.querySelector('faq-block') || document.querySelector('.contact-us__faq');
      if (faqBlock) {
        faqBlock.appendChild(feedbackThanks);
      }
    }
    
    // Show feedback message with animation
    feedbackThanks.classList.add('feedback-thanks-animated');
    
    // Hide feedback message after 3 seconds
    setTimeout(() => {
      feedbackThanks.classList.remove('feedback-thanks-animated');
    }, 3000);
    
    // Switch icon from #mec-weizan to #mec-yizan after click
    const faqItems = document.querySelectorAll('.faq-item');
    if (faqItems[index]) {
      const feedbackBtn = type === 'like' 
        ? faqItems[index].querySelector('.answer__feedback__like .mec-icon use') 
        : faqItems[index].querySelector('.answer__feedback__dislike .mec-icon use');
      
      if (feedbackBtn) {
        feedbackBtn.setAttribute('xlink:href', '#mec-yizan');
        
        // Optional: Disable button after click to prevent multiple toggles
        const parentBtn = feedbackBtn.closest('div');
        if (parentBtn) {
          parentBtn.style.cursor = 'default';
          parentBtn.style.opacity = '0.7';
        }
      }
    }
    
    // Show contact modal if user clicked 'unsolved'
    if (type === 'dislike') {
      this.showContactModal();
    }
    
    // Log feedback for tracking
    console.log(`Feedback submitted: ${type} for FAQ item ${index + 1}`);
  }
  
  showContactModal() {
    // Create or get the contact modal
    let contactModal = document.querySelector('.contact-modal');
    
    // 从HTML中获取配置数据（由Liquid渲染）
    const getConfigValue = (key, defaultValue) => {
      // 先尝试精确匹配section id的元素
      let element = document.querySelector(`[data-contact-modal-config="${key}"][data-section]`);
      if (!element) {
        // 如果没有找到带section属性的元素，尝试找所有带data-contact-modal-config的元素
        element = document.querySelector(`[data-contact-modal-config="${key}"]`);
      }
      return element?.dataset.value || defaultValue;
    };
    
    const getButtonConfig = (buttonNumber) => {
      return {
        title: getConfigValue(`button${buttonNumber}_title`, buttonNumber === 1 ? 'Email Us' : 'Live Chat'),
        description: getConfigValue(`button${buttonNumber}_desc`, buttonNumber === 1 ? 'Get detailed support via email' : 'Chat with support in real-time'),
        icon: getConfigValue(`button${buttonNumber}_icon`, ''),
        url: getConfigValue(`button${buttonNumber}_url`, buttonNumber === 1 ? 'mailto:support@example.com' : 'https://example.com/chat')
      };
    };
    
    if (!contactModal) {
      // Create modal backdrop
      contactModal = document.createElement('div');
      contactModal.className = 'contact-modal';
      
      // Create modal content
      const modalContent = document.createElement('div');
      modalContent.className = 'contact-modal__content';
      
      // Create modal header with title and close button
      const modalHeader = document.createElement('div');
      modalHeader.className = 'contact-modal__header';
      
      const modalTitle = document.createElement('h3');
      modalTitle.className = 'contact-modal__title';
      modalTitle.textContent = getConfigValue('title', 'We\'re here to help');
      
      const closeButton = document.createElement('button');
      closeButton.className = 'contact-modal__close';
      closeButton.textContent = '×';
      closeButton.addEventListener('click', () => {
        this.hideContactModal();
      });
      
      modalHeader.appendChild(modalTitle);
      modalHeader.appendChild(closeButton);
      
      // Create modal body with contact options
      const modalBody = document.createElement('div');
      modalBody.className = 'contact-modal__body';
      
      const modalDescription = document.createElement('p');
      modalDescription.className = 'contact-modal__description';
      modalDescription.textContent = getConfigValue('description', 'Please choose your preferred contact method:');
      
      // Create contact buttons container
      const contactButtons = document.createElement('div');
      contactButtons.className = 'contact-buttons';
      
      // Get button configurations
      const button1Config = getButtonConfig(1);
      const button2Config = getButtonConfig(2);
      
      // Contact button 1
      const contactButton1 = document.createElement('a');
      contactButton1.className = 'contact-button';
      contactButton1.href = button1Config.url;
      
      const iconContainer1 = document.createElement('div');
      iconContainer1.className = 'contact-button__icon';
      
      if (button1Config.icon) {
        // Use configured image icon
        const iconImg = document.createElement('img');
        iconImg.src = button1Config.icon;
        iconImg.alt = `${button1Config.title} icon`;
        iconImg.style.maxWidth = '24px';
        iconImg.style.maxHeight = '24px';
        iconContainer1.appendChild(iconImg);
      } else {
        // Fallback to emoji icon
        iconContainer1.textContent = '✉️';
      }
      
      const textContainer1 = document.createElement('div');
      textContainer1.className = 'contact-button__text';
      
      const title1 = document.createElement('div');
      title1.className = 'contact-button__title';
      title1.textContent = button1Config.title;
      
      const description1 = document.createElement('div');
      description1.className = 'contact-button__description';
      description1.textContent = button1Config.description;
      
      textContainer1.appendChild(title1);
      textContainer1.appendChild(description1);
      
      contactButton1.appendChild(iconContainer1);
      contactButton1.appendChild(textContainer1);
      
      // Contact button 2 - Live Chat
      const contactButton2 = document.createElement('button');
      contactButton2.className = 'contact-button';
      contactButton2.type = 'button';
      
      const iconContainer2 = document.createElement('div');
      iconContainer2.className = 'contact-button__icon';
      
      if (button2Config.icon) {
        // Use configured image icon
        const iconImg = document.createElement('img');
        iconImg.src = button2Config.icon;
        iconImg.alt = `${button2Config.title} icon`;
        iconImg.style.maxWidth = '24px';
        iconImg.style.maxHeight = '24px';
        iconContainer2.appendChild(iconImg);
      } else {
        // Fallback to emoji icon
        iconContainer2.textContent = '💬';
      }
      
      const textContainer2 = document.createElement('div');
      textContainer2.className = 'contact-button__text';
      
      const title2 = document.createElement('div');
      title2.className = 'contact-button__title';
      title2.textContent = button2Config.title;
      
      const description2 = document.createElement('div');
      description2.className = 'contact-button__description';
      description2.textContent = button2Config.description;
      
      textContainer2.appendChild(title2);
      textContainer2.appendChild(description2);
      
      contactButton2.appendChild(iconContainer2);
      contactButton2.appendChild(textContainer2);
      
      // Add click event to trigger the existing chat widget button
      contactButton2.addEventListener('click', () => {
        // Find and click the existing chat widget button using multiple strategies
        let chatWidgetButton = null;
        
        // Strategy 1: Try by ID directly
        chatWidgetButton = document.querySelector('#button-body');
        
        // Strategy 2: Try by data-testid if not found
        if (!chatWidgetButton) {
          chatWidgetButton = document.querySelector('[data-testid="widgetButtonBody"]');
        }
        
        // Strategy 3: Try with more complex selector
        if (!chatWidgetButton) {
          chatWidgetButton = document.querySelector('button[id="button-body"][data-testid="widgetButtonBody"]');
        }
        
        // Try to trigger the button click
        if (chatWidgetButton) {
          // Use dispatchEvent for more reliable click triggering
          const clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
          });
          chatWidgetButton.dispatchEvent(clickEvent);
          console.log('Live chat widget button clicked successfully');
        } else {
          console.warn('Chat widget button not found using multiple strategies');
          // Fallback behavior in case the chat widget button is not available
          if (button2Config.url) {
            window.open(button2Config.url, '_blank');
          }
        }
        
        // Hide the modal after clicking
        this.hideContactModal();
      });
      
      contactButtons.appendChild(contactButton1);
      contactButtons.appendChild(contactButton2);
      
      modalBody.appendChild(modalDescription);
      modalBody.appendChild(contactButtons);
      
      // Assemble the modal
      modalContent.appendChild(modalHeader);
      modalContent.appendChild(modalBody);
      contactModal.appendChild(modalContent);
      
      // Add styles to the document head
      const style = document.createElement('style');
      style.textContent = `
        .contact-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s ease, visibility 0.3s ease;
        }
        
        .contact-modal.active {
          opacity: 1;
          visibility: visible;
        }
        
        .contact-modal__content {
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          width: 90%;
          max-width: 400px;
          max-height: 80vh;
          overflow-y: auto;
          transform: translateY(-20px);
          transition: transform 0.3s ease;
        }
        
        .contact-modal.active .contact-modal__content {
          transform: translateY(0);
        }
        
        .contact-modal__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 20px 16px;
          border-bottom: 1px solid #f0f0f0;
        }
        
        .contact-modal__title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #333;
        }
        
        .contact-modal__close {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #999;
          padding: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .contact-modal__close:hover {
          color: #333;
        }
        
        .contact-modal__body {
          padding: 20px;
        }
        
        .contact-modal__description {
          margin-bottom: 20px;
          color: #666;
          font-size: 14px;
          line-height: 1.4;
        }
        
        .contact-buttons {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        
        .contact-button {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px;
          background-color: #fafafa;
          border: 1px solid #e5e5e5;
          border-radius: 6px;
          text-decoration: none;
          color: inherit;
          transition: all 0.2s ease;
        }
        
        .contact-button:hover {
          background-color: #f0f0f0;
          border-color: #ccc;
          transform: translateY(-2px);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }
        
        .contact-button__icon {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          background-color: white;
          border-radius: 50%;
          border: 1px solid #e5e5e5;
        }
        
        .contact-button__text {
          flex: 1;
          text-align: left;
        }
        
        .contact-button__title {
          font-weight: 500;
          color: #333;
          font-size: 16px;
          margin-bottom: 4px;
        }
        
        .contact-button__description {
          font-size: 14px;
          color: #666;
        }
        
        /* Responsive adjustments */
        @media (max-width: 480px) {
          .contact-modal__content {
            width: 95%;
            margin: 20px;
          }
          
          .contact-button {
            padding: 12px;
          }
        }
      `;
      document.head.appendChild(style);
      
      // Add modal to body
      document.body.appendChild(contactModal);
      
      // Add event listener to close modal when clicking outside
      contactModal.addEventListener('click', (e) => {
        if (e.target === contactModal) {
          this.hideContactModal();
        }
      });
      
      // Add event listener to close modal with Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hideContactModal();
        }
      });
    }
    
    // Show the modal with animation
    contactModal.classList.add('active');
  }
  
  hideContactModal() {
    const contactModal = document.querySelector('.contact-modal');
    if (contactModal) {
      contactModal.classList.remove('active');
      
      // Remove modal from DOM after animation completes
      setTimeout(() => {
        if (contactModal.parentNode) {
          contactModal.parentNode.removeChild(contactModal);
        }
      }, 300);
    }
  }
  
  trackEvent(eventName, eventData) {
    // Event tracking functionality
    console.log(`Event tracked: ${eventName}`, eventData);
  }
}

// Initialize ContactUsManager when DOM is fully loaded
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function() {
    try {
      const contactManager = new ContactUsManager();
      contactManager.init();
    } catch (error) {
      console.error('Failed to initialize Contact Us Manager:', error);
    }
  });
}